import { AspectRatio, Image, AspectRatioProps } from "@chakra-ui/react";
import { fancyBearsFilesUrl, publicUrl } from "config";
import { ImageSize } from "types";

type FancyBearImageProps = Omit<AspectRatioProps, "ratio"> & {
  tokenId?: number;
  size?: ImageSize;
  isDisabled?: boolean;
};

const FancyBearImage = ({
  tokenId,
  size = "512",
  isDisabled = false,
  ...rest
}: FancyBearImageProps) => (
  <AspectRatio
    ratio={1}
    w="full"
    bg="dark.400"
    borderRadius="md"
    overflow="hidden"
    {...rest}
  >
    <Image
      src={
        tokenId !== undefined
          ? `${fancyBearsFilesUrl}/${size}/${tokenId}.png`
          : undefined
      }
      fallbackSrc={`${publicUrl}/bear-placeholder_transparent.png`}
      fit="cover"
      opacity={isDisabled ? 0.5 : 1}
      transition="opacity 0.15s"
    />
  </AspectRatio>
);

export default FancyBearImage;
